import type { QueryKey } from '@tanstack/react-query';

export interface QuantCompletionInvalidationTarget {
  queryKey: QueryKey;
  exact: boolean;
}

/**
 * Every project-scoped read surface whose membership or pinned pointer can change when compute
 * completes. The risk-run key is intentionally the exact `pinned` key: broad risk-run invalidation
 * would needlessly refresh immutable explicitly selected historical runs.
 */
export function quantProjectCompletionInvalidationTargets(
  projectId: string,
): QuantCompletionInvalidationTarget[] {
  return [
    { queryKey: ['quant', 'riskRun', projectId, 'pinned'], exact: true },
    { queryKey: ['quant', 'ingest-status', projectId], exact: true },
    { queryKey: ['quant', 'products', 'run-index', projectId], exact: true },
    { queryKey: ['quant', 'products', 'catalog', projectId], exact: false },
    { queryKey: ['quant', 'products', projectId], exact: false },
    { queryKey: ['quant', 'collections', 'catalog', projectId], exact: true },
    { queryKey: ['quant', 'collections', projectId], exact: false },
    { queryKey: ['quant', 'fleet'], exact: true },
  ];
}

export function quantJobCompletionInvalidationTargets(
  jobId: string,
): QuantCompletionInvalidationTarget[] {
  return [
    { queryKey: ['quant', 'jobs', 'status', jobId], exact: true },
    { queryKey: ['quant', 'jobs', 'result', jobId], exact: true },
    { queryKey: ['quant', 'jobs', 'scenario-linkage', jobId], exact: true },
  ];
}
